<template>
  <b-card
    img-alt="Image"
    img-top
    tag="article"
    style="max-width: 20rem; border-radius: 15px;background-color: #b2ac88;"
    class="mb-2"
  >
    <b-img
        v-if="imgURL"
      fluid
      :src="imgURL"
      @click="handleGoToURLLocation"
      alt="Image 2"
    />
    <b-card-text>
      <p>{{ comment && comment.length > maxLen ? `${comment.substring(0, maxLen)} ...` : comment}}</p>
    </b-card-text>
    <time-ago
        :refresh="1"
        :datetime="createdAt"
    /> ago
  </b-card>
</template>

<script>
import TimeAgo from "vue2-timeago";
export default {
  name: "Memory_Card",
  components: {
    TimeAgo
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    memoryEntity: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleGoToURLLocation() {
      if (this.urlLocation) window.open(this.urlLocation, "_blank");
    },
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      maxLen:120,
      imgURL:
        this.memoryEntity && this.memoryEntity.form && this.memoryEntity.form.imgURL ?
            this.memoryEntity.form.imgURL : null,
      comment:
          this.memoryEntity && this.memoryEntity.form && this.memoryEntity.form.comment ?
              this.memoryEntity.form.comment : null,
      createdAt: this.memoryEntity && this.memoryEntity.form && this.memoryEntity._created_at ?
        this.memoryEntity._created_at.toDate() : null
    };
  }
};
</script>
